module.exports = __webpack_public_path__ + "media/packs/images/flags/GW-573c5ff6594c4d8d995beb3ac11a88c2.svg";